import React, {useEffect, useState} from 'react';
import './index.scss';
import PropTypes from "prop-types";
import {Button} from "../../atoms";
import {ButtonColor} from "../../atoms/button/Button";
import { CSVLink, CSVDownload } from "react-csv";
import PSIcon from "../../PSIcon";
import moment from "moment";
import {transformDatetoUnix} from "../../../../scripts/Util";
import {CalendarRange} from "../index";
import PSModal from "../../PSModal";


const NAME_FILE= "listadoUsuariosProtecta.csv";
const HEADERS_FIELDS_CSV = [
  { label: "Tipo documento", key: "tipoDoc" },
  { label: "Numero documento", key: "nroDoc" },
  { label: "Nombres", key: "name" },
  { label: "Correo electronico", key: "mail" },
  { label: "Estado" , key: 'status'},
  { label: "Bloqueado", key: 'enabled'},
  { label: "Celular", key: "phone" },
  { label: "Promociones", key: "pdp" },
  { label: "Fecha de registro", key: "createDate" },
  { label: "Fecha de actualización", key: "updateDate" }
];

const NAME_FILE_COMPANY= "listadoUsuariosEmpresaProtecta.csv";
const HEADERS_FIELDS_COMPANY_CSV = [
  { label: "RUC", key: "ruc" },
  { label: "Nombres", key: "name" },
  { label: "Correo electronico", key: "mail" },
  { label: "Estado" , key: 'status'},
  { label: "Bloqueado", key: 'enabled'},
  { label: "Promociones", key: "pdp" },
  { label: "Fecha de registro", key: "createDate" },
  { label: "Fecha de actualización", key: "updateDate" }

];

const DEFAULT_VALUE_FROM= moment(new Date()).subtract(2, 'months').format("YYYY-MM-DD");
const DEFAULT_VALUE_TO= moment(new Date()).format("YYYY-MM-DD");

const DateRange = ({onSelectFrom, onSelectTo}) => {
  return (
    <div>
      <input
        className="ml-0"
        type="date"
        id="start"
        min="2020-01-01"
        max="2022-01-01"
        onChange={(e)=> onSelectFrom(e.target.value) }
      />
      <input
        className="ml-0"
        type="date"
        id="start"
        min="2020-01-01"
        max="2022-01-01"
        onChange={(e) => onSelectTo(e.target.value)}
      />
    </div>
  )
};

const HeaderSection = React.forwardRef(({ className, listToExport, title, isNatural ,hasCalendar, hasSearchInput, openModalCreateUser,onSearchCalendar,onSearchRefresh, hasCreateUser, onSearchByDoc, hasFindUser, openModalFindUser}, ref) => {
    return (
      <div ref={ref} className={`header__section ${className}`}>
        <div className="natural-user__header">
          <h2 className="color-blue">{title}</h2>
        </div>
        <div className="option-filters">
          {hasSearchInput && (
            <input type="text" placeholder="Buscar por N° DOC" onChange={(e) => onSearchByDoc(e)} />
          )}
          {hasCalendar && (
              <CalendarRange onRefresh={onSearchRefresh} onSearch={(date)=> onSearchCalendar(date)}/>
          )}
          {hasCreateUser && (
            <Button icon="userCreate" className="user-create" type={ButtonColor.white} onClick={openModalCreateUser}>
              Crear
            </Button>
          )}
          {hasFindUser && (
            <Button icon="search" className="user-create" type={ButtonColor.white} onClick={openModalFindUser}>
              Buscar...
            </Button>
          )}

          <Button className={ButtonColor.blue}>
            <CSVLink onClick={() =>  setTimeout(() => {alert('Su archivo se ha descargado con éxito')}, 1000)} headers={isNatural ? HEADERS_FIELDS_CSV :HEADERS_FIELDS_COMPANY_CSV } data={listToExport} filename={isNatural ? NAME_FILE : NAME_FILE_COMPANY}>
              {' '}
              Exportar CSV{' '}
            </CSVLink>
          </Button>
        </div>
      </div>
  )
});

HeaderSection.displayName = 'HeaderSection';

HeaderSection.defaultProps = {
  className: '',
  title: 'Usuarios',
  listToExport: [],
  isNatural: true,
  openModalCreateUser: () => {},
  hasCreateUser: false,
  hasCalendar: false,
  hasSearchInput: false,
  onSearchCalendar: () => {},
  onSearchRefresh : () => {},
  onSearchByDoc: () => {},
  openModalFindUser: () => {},
  hasFindUser: false,
};

HeaderSection.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  listToExport: PropTypes.array,
  isNatural: PropTypes.bool,
  openModalCreateUser: PropTypes.function,
  hasCreateUser: PropTypes.bool,
  hasSearchInput: PropTypes.bool,
  onSearchCalendar: PropTypes.func,
  hasCalendar: PropTypes.bool,
  onSearchRefresh : PropTypes.func,
  onSearchByDoc: PropTypes.func,
  hasFindUser: PropTypes.bool,
  openModalFindUser: PropTypes.func,
};

export default HeaderSection;
